module.exports = __webpack_public_path__ + "img/Nissan_logo_300x300.fa567e1b.png";